// extracted by mini-css-extract-plugin
export default {"container":"Confirm_container__wj8TR"};